const IMAGE_BASE_PATH = 'https://images.atsu.me'

export function coverKeyFromCover(cover?: string | null, originalCover?: string | null): string {
  return ((cover?.trim().length ? cover : originalCover) || '').split('.')[0].trim()
}

export function getCoverUrl(cover?: string | null, originalCover?: string | null): string {
  const coverName = coverKeyFromCover(cover, originalCover)
  if (!coverName) return ''
  return `${IMAGE_BASE_PATH}/thumbs/${encodeURIComponent(coverName)}-600.webp`
}
